import { defineComponent, ref, onMounted } from 'vue';

const CONSENT_KEY = 'cookies_consent';

export default defineComponent({
  name: 'SCookieBanner',
  setup() {
    const visible = ref(false);

    onMounted(() => {
      const consent = localStorage.getItem(CONSENT_KEY);
      if (!consent) {
        visible.value = true;
      }
    });

    const accept = () => {
      localStorage.setItem(CONSENT_KEY, 'accepted');
      visible.value = false;
      loadAnalytics();
    };

    const reject = () => {
      localStorage.setItem(CONSENT_KEY, 'rejected');
      visible.value = false;
    };

    const loadAnalytics = () => {
      if (window.location.hostname !== 'platform.stemdo.io') return;

      // Google Analytics (gtag)
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-PG9XG1TL61';
      document.head.appendChild(gtagScript);
      gtagScript.onload = () => {
        (window as any).dataLayer = (window as any).dataLayer || [];
        function gtag(...args: any[]) {
          (window as any).dataLayer.push(args);
        }
        gtag('js', new Date());
        gtag('config', 'G-PG9XG1TL61');
        (window as any).gtag = gtag;
      };

      // Google Tag Manager
      (function (w: any, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0];
        const j: any = d.createElement(s);
        const dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-WDVH3TLF');
    };

    return { visible, accept, reject };
  }
});
